// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SortController from "./sort_controller.js"
application.register("sort", SortController)

import Backend__QuizLoaderController from "./quiz_loader_controller"
application.register("backend-quiz-loader", Backend__QuizLoaderController)
